import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ScrollToTop from '../common/ScrollToTop';
import BusinessAnalytics from './BusinessAnalytics';
import CloudSolutions from './CloudSolutions';
import IntelligentERP from './IntelligentERP';
import SupplyChainManagement from './SupplyChainManagement';

const FeatureRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="cloud-solutions" element={<CloudSolutions />} />
        <Route path="business-analytics" element={<BusinessAnalytics />} />
        <Route path="supply-chain-management" element={<SupplyChainManagement />} />
        <Route path="intelligent-erp" element={<IntelligentERP />} />
        {/* Redirect to home if feature not found */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default FeatureRoutes;
